import React from 'react'
import Copy from 'transfix-ui/components/Copy'
import { INLINE_MESSAGE_VARIANTS, InlineMessage } from 'transfix-ui/components/InlineMessage'
import { Box, Typography } from 'transfix-ui/core'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { Card, CardHeader, brandColors } from 'transfix-ui'
import { formatQuote } from '../../utils/formatFocusPanelContents'

interface ITransfixQuotesCardProps {
  className?: string
  allIn?: number | null
  linehaul?: number | null
  isDoNotBid?: boolean
}

const useStyles = makeStyles(() => ({
  quoteLines: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '74px',
    alignItems: 'center',
    borderBottom: `1px solid ${brandColors.coolGray3}`,
  },
}))

export const TransfixQuotesCard = ({
  allIn,
  className,
  isDoNotBid,
  linehaul,
}: ITransfixQuotesCardProps) => {
  const classes = useStyles()
  const formattedAllIn = formatQuote(allIn)
  const copyAllIn = allIn ? Number(allIn.toFixed(2)).toString() : formattedAllIn
  const formattedLinehaul = formatQuote(linehaul)
  const copyLinehaul = linehaul ? Number(linehaul.toFixed(2)).toString() : formattedLinehaul

  return (
    <Card className={className}>
      <CardHeader>
        <div>
          <Typography variant='overline'>TRANSFIX QUOTES</Typography>
        </div>
      </CardHeader>
      {isDoNotBid ? (
        <InlineMessage
          type={INLINE_MESSAGE_VARIANTS.WARNING}
          message='We suggest to not bid on this load as a do not bid rule was applied.'
        />
      ) : (
        <div>
          <div className={classes.quoteLines}>
            <Typography variant='h3'>All-In Quote</Typography>
            <Box display='flex'>
              <Typography variant='h3'>{formattedAllIn}</Typography>
              <Copy copyText={copyAllIn} useIcon alignClass='left' />
            </Box>
          </div>
          <div className={classes.quoteLines}>
            <Typography variant='h3'>Linehaul Quote</Typography>
            <Box display='flex'>
              <Typography variant='h3'>{formattedLinehaul}</Typography>
              <Copy copyText={copyLinehaul} useIcon alignClass='left' />
            </Box>
          </div>
        </div>
      )}
    </Card>
  )
}
